import React, {useEffect} from "react";
import './WarmHoursManagement.scss'
import {useDispatch, useSelector} from "react-redux";
import {deleteWarmHour, getWarmHours, selectHour} from "../../store/actions/warmHoursActions";
import Spinner from "../_common/Spinner";
import List from "../_common/List";
import {toggleModal} from "../../store/actions/toggleModalActions";
import WarmHoursModal from "./WarmHoursModal";
import ConfirmationModal from "../_common/ConfirmationModal";

const selector = state => {
    const { language, hours, modalState } = state;
    return {
        t: language.translator,
        pending: hours.pending,
        warmHours: hours.warmHours,
        selected: hours.selected.hour,
        modalState: modalState
    }
};
const WarmHoursManagement = () => {
    const { t, pending, warmHours, modalState, selected} = useSelector(selector);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getWarmHours())
    }, []);

    const toggleDeleteWarmHour = () => {
        dispatch(toggleModal(true, 'Delete Rising Hour'))
    }
    const toggleEditWarmHour = () => {
        dispatch(toggleModal(true, 'Edit Rising Hour'))
    }
    const deleteWarmHourMethod = (configId) => {
        dispatch(deleteWarmHour(configId))
        dispatch(toggleModal(false, 'Delete Rising Hour'))
    }

    return (
        <div className={'hoursWrapper'}>
            <div className={'hoursList'}>
                <div className="hoursHeader">
                    <span>{t.gettext('Rising Hours')}</span>
                    <div className='addAlertRuleBtn'
                         onClick={() => dispatch(toggleModal(true, 'Add Rising Hour'))}
                    >
                        <span className='material-icons'>add</span>
                    </div>
                </div>
                {pending
                    ? <div className='page'>
                        <Spinner size={300}/>
                    </div>
                    : <List
                        roundTopCorners
                        items={warmHours}
                        scroll
                        columnsNames={[t.gettext('Name--item')]}
                        columns={['configName','','']}
                        columnsWidths={['90%','5%','5%']}
                        getItemsMethod={getWarmHours}
                        selected={selected}
                        editColumn={2}
                        deleteColumn={3}
                        deleteMethod={toggleDeleteWarmHour}
                        editMethod={toggleEditWarmHour}
                        selectItemMethod={selectHour}
                    />
                }
            </div>
            {(modalState.flag && modalState.modal === 'Add Rising Hour') &&
                <WarmHoursModal />
            }
            {(modalState.flag && modalState.modal === 'Edit Rising Hour') &&
                <WarmHoursModal
                    edit
                />
            }
            {(modalState.flag && modalState.modal === 'Delete Rising Hour') &&
                <ConfirmationModal
                    text={t.gettext('Do you want to delete')}
                    deleteModal
                    closeMethod={() =>  dispatch(toggleModal(false, 'Delete Rising Hour'))}
                    confirmMethod={() => deleteWarmHourMethod(selected.configId)}
                    confirmButtonText={t.gettext('Delete')}
                />
            }
        </div>
    )
}

export default WarmHoursManagement
